(function () {

    var wrapper = $('div.conference-days');
    var button = wrapper.find('ul input[type="button"]');
    var days = wrapper.find('> div.day');

    days.hide().first().show();
    button.first().addClass('button--purple');
    
    wrapper.find('ul input[type="button"]').on('click', function(){

        var $this = $(this);
        var daytoShow = $this.data('day');
        var isPurple = $this.hasClass('button--purple');

        if(!isPurple){
            wrapper.find('ul input[type="button"]').removeClass('button--purple');
            $this.addClass('button--purple');
        }

        wrapper.find('> div').hide();
        wrapper.find('>.' + daytoShow).show();

    });

})();